import { useLocation } from "react-router-dom";
import PreviewComponent from "./PreviewComponent";
import FieldsComponent from "./address/FieldsComponent";
// import PaymentListing from "../Payment/PaymentListing";
import PreferenceComponents from "./Preferences/PreferenceComponents";
import "src/scss/checkbox.css";
import { useRecoilState, useRecoilValue } from "recoil";
import { authState } from "src/atom/authState";
// import PaymentListing from "../Payment/PaymentListing";

const PreviewPage = ({ data, personalData, formData, masterQuestions }) => {
  const location = useLocation();
  const auth = useRecoilValue(authState);
  masterQuestions = masterQuestions || location.state.masterQuestions || {};
  formData = formData || location.state.formData || {};

  return (
    <>
      <div className="card">
        <div
          className="card-header text-white d-flex justify-content-between "
          style={{ backgroundColor: "#3C4B64" }}
        >
          <div>Submitted Details</div>
          <div
            type="button"
            className="bg-light text-dark"
            style={{
              color: "#3C4B64",
              cursor: "crosshair",
              padding: "2px 10px",
              borderRadius: "5px",
            }}
          >
            {formData?.is_new ? "New Candidate" : "Old Candidate"}
          </div>
        </div>
        <div className="card-body">
          {formData?.personal_details && (
            <div className="row">
              <div className="col-lg-9 col-md-8 col-sm-12">
                <PreviewComponent
                  questions={masterQuestions.personal_details}
                  data={formData.personal_details}
                  heading="Personal Details"
                ></PreviewComponent>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-12">
                <PreviewComponent
                  questions={masterQuestions.photo_sign}
                  data={formData.photo_sign}
                  heading="Photo & Signature"
                ></PreviewComponent>
              </div>
            </div>
          )}
          {formData?.address_details && (
            <div className="row mt-4">
              <div className="col">
                <div
                  className="card-header text-white"
                  style={{ backgroundColor: "#3C4B64" }}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="mr-auto">Mailing Address</span>
                  </div>
                </div>
                {/* <div>
                  <FieldsComponent
                    data={formData.address_details}
                    type="Office"
                    edit={false}
                  ></FieldsComponent>
                </div> */}
              </div>
            </div>
          )}
          {formData?.address_details && (
            <div className="row mt-1">
              <div className="col">
                <div>
                  <FieldsComponent
                    data={formData.address_details}
                    type="Correspondance"
                    edit={false}
                  ></FieldsComponent>
                </div>
              </div>
            </div>
          )}
          <div style={{ marginBottom: "10px" }}>
            <input
              type="checkbox"
              id="toggleForm"
              checked={formData?.address_details?.sameAsCorr}
              className="custom-checkbox"
            />
            <label
              className="ms-3"
              htmlFor="toggleForm"
              style={{ fontSize: "18px" }}
            >
              <b>Permanent Address same as Present Residential Address</b>
            </label>
          </div>
          {!formData?.address_details?.sameAsCorr && (
            <>
              {formData?.address_details && (
                <div className="row">
                  <div className="col">
                    <div>
                      <FieldsComponent
                        data={formData.address_details}
                        type="Permanent"
                        edit={false}
                      ></FieldsComponent>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
          {formData?.category_details && (
            <div className="row mt-4">
              <div className="col">
                <PreviewComponent
                  questions={masterQuestions.category_details}
                  data={formData.category_details}
                  heading="Professional Details"
                ></PreviewComponent>
              </div>
            </div>
          )}

          {formData?.qualification && (
            <div className="row mt-4">
              <div className="col">
                <PreviewComponent
                  questions={masterQuestions.qualification}
                  data={formData.qualification}
                  heading="Qualifications"
                ></PreviewComponent>
              </div>
            </div>
          )}
          {formData?.qualificationCategory && (
            <div className="row mt-4">
              <div className="col">
                <PreviewComponent
                  questions={masterQuestions.qualificationCategory}
                  data={formData.qualificationCategory}
                  heading="Post Category"
                ></PreviewComponent>
              </div>
            </div>
          )}
          {auth?.role !== "CANDIDATE" && (
            <>
              {formData?.declaration && (
                <div className="row mt-4">
                  <div className="col">
                    <PreviewComponent
                      questions={masterQuestions.declaration}
                      data={formData.declaration}
                      heading="Signed Declaration"
                    ></PreviewComponent>
                  </div>
                </div>
              )}
            </>
          )}

          {/* {formData?.payment && formData.payment.length > 0 && (
            <div className="row">
              <div className="col">
                <div className="card">
                  <div
                    className="card-header text-white"
                    style={{ backgroundColor: "#3C4B64" }}
                  >
                    Payments
                  </div>
                  <div className="card-body">
                    <PaymentListing previousPayments={formData?.payment} />
                  </div>
                </div>
              </div>
            </div>
          )} */}

          {formData?.ipAddress && (
            <>
              <hr />
              <span style={{ color: "red", fontStyle: "italic" }}>
                You have submitted your declaration on{" "}
                <b>{formData?.submittedOn}</b> from IPAddress:{" "}
                <b>{formData?.ipAddress}</b>
              </span>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default PreviewPage;
